import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import PolicyTechOwnersSettings from './policytech-owners-settings';
import PolicyTechSourcesSettings from './policytech-sources-settings';

// Each section loads and saves independently — they hit different endpoints, and a
// combined save could half-succeed. One section failing must not block the other.
export default function PolicyTechSettings() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>PolicyTech</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <section className="space-y-4">
          <h3 className="text-sm font-semibold">Content owners</h3>
          <PolicyTechOwnersSettings />
        </section>
        <Separator />
        <section className="space-y-4">
          <h3 className="text-sm font-semibold">Zip sources</h3>
          <PolicyTechSourcesSettings />
        </section>
      </CardContent>
    </Card>
  );
}
